<template>
    <div class="p-2">
        <div class="text-right mb-3">
            <b-button v-b-modal="'addFormModal'">Crear</b-button>
        </div>
        <div class="row">
            <div class="input-group input-group-sm p-2 col-md-9">
                <input type="search" name="table_search" class="form-control ml-2" placeholder="Buscar" v-model="search" :disabled="loading"/>
        
                <div class="input-group-append">
                    <Button @click="getLesiones()" type="submit" variant="default" icon="fas fa-search" :disabled="loading" />
                </div>
            </div>
            <b-form-select class="col-md-3 text-center m-auto" style="max-width: 237px;" v-model="selected" :options="options" :disabled="loading"/>
        </div>
        <div v-if="loading" class="text-center mt-4">
            <b-spinner label="Cargando..."/>
        </div>
        <div v-else>
            <div class="table-responsive">
                <b-table striped hover :items="lesiones" :fields="fields">
                    <template #cell(opciones)="data">
                        <b-button-group>
                            <b-dropdown dropleft text="Opciones">
                                <b-dropdown-item v-b-modal="'editFormModal'" @click="lesion = data.item, editar = true">Editar</b-dropdown-item>
                                <b-dropdown-item id="borrar-lesion-test" v-b-modal="'delete'" @click="lesion_id = data.item.id, $nextTick(() => { $modal.show('borrar-lesion-' + lesion_id); });">Borrar</b-dropdown-item>
                            </b-dropdown>
                        </b-button-group>
                    </template>
                </b-table>
            </div>
        </div>

        <b-modal id="editFormModal" title="EDITAR LESIÓN" hide-footer centered v-if="editar">
            <EditFormLesiones :lesion="lesion" :base_id="base_id" @editarLesion="getLesiones(), editar = false"/>
        </b-modal>

        <BorrarModalComponent
            :name="'borrar-lesion-' + lesion_id"
            :title="'Borrar lesión'"
            borrarTitle="Datos de la lesión"
            confirmButton="¿BORRAR LESIÓN?"
            v-on:close="() => $modal.hide('borrar-lesion-' + lesion_id)"
            v-on:confirm="() => borrarLesion()"
        >
            <ul class="list-group list-group-unbordered mb-3">
                <li class="list-group-item">
                    <b>ID:</b> <a>{{ lesion?.id }}</a>
                </li>
                <li class="list-group-item">
                    <b>Fecha baja:</b> <a>{{ lesion?.fecha_baja || 'N/A' }}</a>
                </li>
                <li class="list-group-item">
                    <b>Fecha alta:</b> <a>{{ lesion?.fecha_alta || 'N/A' }}</a>
                </li>
                <li class="list-group-item">
                    <b>Orientación diagnóstica:</b> <a>{{ lesion?.orientacion_diagnostica || 'N/A' }}</a>
                </li>
            </ul>
        </BorrarModalComponent>
        <div v-if="lesiones.length > 0" class="d-md-flex">
            <div class="d-md-flex">
                <ElementosPorPaginaComponent @input="(n) => numPage = n" :value="numPage" />
                <b-pagination 
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-number
                    last-number
                />
            </div>
        </div>


        <b-modal id="addFormModal" title="CREAR LESIÓN" hide-footer centered v-model="crear">
            <AddFormLesiones :lesiones="lesiones" :base_id="base_id" @crearLesion="getLesiones(), crear = false"/>
        </b-modal>
    </div>
</template>

<script>
    import EditFormLesiones from '@/components/backend/bases/components/forms/EditFormLesiones.vue';
    import AddFormLesiones from '@/components/backend/bases/components/forms/AddFormLesiones.vue';
    import ElementosPorPaginaComponent from '@/components/backend/components/ElementosPorPaginaComponent.vue';
    import BorrarModalComponent from '@/components/backend/components/BorrarModalComponent.vue';

    export default {
        props: [
            'base_id',
        ],
        data() {
            return {
                fields: [
                    { key: 'fecha_baja', label: 'Fecha baja', style: 'text-center', class: 'text-center' },
                    { key: 'fecha_alta', label: 'Fecha alta', style: 'text-center', class: 'text-center' },
                    { key: 'orientacion_diagnostica', label: 'Orientación Diagnóstica', class: 'text-center' },
                    { key: 'opciones', label: 'Opciones', class: 'text-center' }
                ],
                options: [
                    {value: 'orientacion_diagnostica', text: 'Orientación Diagnóstica'},
                    {value: 'fecha_baja', text: 'Fecha Baja'},
                    {value: 'fecha_alta', text: 'Fecha Alta'},
                ],
                crear: false,
                editar: false,
                lesion_id: null,
                lesion: null,
                rows: 1,
                perPage: 1,
                currentPage: 1,
                numPage: 5,
                search: '',
                lesiones: [],
                selected: 'orientacion_diagnostica',
                loading: false
            }
        },
        methods: {
            borrarLesion() {
                this.loading = true;

                const params = { 
                    lista_id: this.lista_id,
                    base_id: this.base_id,
                    lesion_id: this.lesion_id,
                    filters: {}
                };

                this.$store.dispatch(this.config.getVuexAlias('back.bases.lesiones.delete'), params).then(() => {
                    this.$toast.success('Lesión eliminada correctamente.');
                    this.currentPage = this.lesiones.length > 1 ? this.currentPage : 1;
                    this.getLesiones();
                    this.$modal.hide('borrar-lesion-' + this.lesion_id);
                }).catch(e => {
                    this.$toast.error('An error occurred');
                }).finally(() => this.loading = false);
            },
            getLesiones() {
                this.loading = true;

                const params = {
                    lista_id: this.lista_id,
                    base_id: this.base_id,
                    filters: {
                        page: this.currentPage,
                        numPage: this.numPage,
                        search: this.search,
                        selected: this.selected
                    }
                };

                this.$store.dispatch(this.config.getVuexAlias('back.bases.lesiones'), params).then(res => {
                    this.rows = res.data.meta.last_page;
                    this.perPage = res.data.meta.per_page > 5 ? res.data.per_page : 1;
                    this.currentPage = res.data.meta.current_page;
                    this.lesiones = res.data.data;
                }).catch(e => {}).finally(() => this.loading = false);
            },
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        components: {
            EditFormLesiones,
            AddFormLesiones,
            ElementosPorPaginaComponent,
            BorrarModalComponent
        },
        mounted(){
            this.getLesiones();
        },
        watch: {
            currentPage() {
                this.getLesiones();
            },
            numPage() {
                this.currentPage = 1;
                this.getLesiones();
            },
            search(){
                setTimeout(() => {
                    this.currentPage = 1;
                    this.getLesiones();
                }, 500)
           
            }
        }
    }
</script>